export default __webpack_public_path__ + "static/media/realtimedb_openapi.c1c21a2f.yaml";